"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBFaqContextualDropdown;
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _helpCircle = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/help-circle.svg"));
var _chevron_down = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron_down.svg"));
var _chevron_up = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron_up.svg"));
var _reactRouterDom = require("react-router-dom");
var _index = _interopRequireDefault(require("@svb/api-loading-component/dist/components/index"));
var _faqFilterService = _interopRequireDefault(require("./helpers/faqFilterService"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Dropdown cmponent for support contextual dropdown
 * By Prashant Bhatt<pbhatt@svb.com> (www.svb.com)
 * Summary
 * This component renders dropdown based on filtered value
 */

/**
 * Custom props to Render our own specs
 * @param {props} props
 * @returns
 */
function SVBFaqContextualDropdown(props) {
  const {
    filterOption,
    faqsItems,
    extraClasses
  } = props;
  const [open, setOpen] = (0, _react.useState)(false);
  const [mounted, setMounted] = (0, _react.useState)(false);
  const [results, setResults] = (0, _react.useState)([]);
  const [loadingRes, setloadingRes] = (0, _react.useState)(false);
  const ref = (0, _react.useRef)();
  const generateFaqSlugTitle = str => str.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
  const filterResults = () => {
    (0, _faqFilterService.default)(filterOption.filterType, filterOption.filterValue, faqsItems, filterOption.faqTitle).then(x => {
      let results = x;
      if (results && results.length > 0) {
        setResults(results);
        setloadingRes(false);
      } else {
        setResults([]);
        setloadingRes(false);
      }
    }).catch(err => {
      console.log(err);
      setloadingRes(false);
    });
  };
  (0, _react.useEffect)(() => {
    const checkIfClickedOutside = e => {
      if (open && ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [open]);
  (0, _react.useEffect)(() => {
    filterResults();
    setMounted(true);
  }, [filterOption]);
  if (!mounted) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const finalClass = extraClasses ? extraClasses + ' dropdown' : 'dropdown';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(finalClass, " w-100 mt-3"),
    ref: ref
  }, loadingRes ? /*#__PURE__*/_react.default.createElement(_index.default, null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    onClick: () => setOpen(!open),
    type: "button",
    className: "dropdown_trigger w-100 rounded-1"
  }, filterOption.filterType === 'common' ? "View common questions" : "View ".concat(filterOption.filterDisplayName ? filterOption.filterDisplayName : 'related', " questions"), /*#__PURE__*/_react.default.createElement("span", {
    className: "dropdown_indicator"
  }, /*#__PURE__*/_react.default.createElement("img", {
    width: 16,
    height: 16,
    src: open ? _chevron_up.default : _chevron_down.default,
    alt: "Contextual FAQ Filter Dropdown Icon"
  }))), /*#__PURE__*/_react.default.createElement("ul", {
    className: "list dropdown_menu w-100 ps-3 pt-3 pe-3 pb-4 rounded-1",
    style: {
      display: open ? "block" : "none"
    }
  }, results && results.length > 0 ? results.map((result, i) => {
    const faqLink = '/faqs/' + generateFaqSlugTitle(result.title);
    if (i < (filterOption.resultCount || 3)) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: i,
        className: "faq-question-item d-flex mb-3"
      }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
        width: 20,
        height: 20,
        src: _helpCircle.default,
        className: "help-circle",
        alt: "FAQ Help Icon"
      })), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        className: "faq-question-item-link ps-3",
        to: faqLink,
        onClick: () => setOpen(!open)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "faq-question-item--heading"
      }, result.title), /*#__PURE__*/_react.default.createElement("div", {
        className: "faq-question-item--desc pt-1"
      }, result.description)));
    }
  }) : /*#__PURE__*/_react.default.createElement("p", null, "No related questions found, you can click below to view all FAQs"), /*#__PURE__*/_react.default.createElement("div", {
    className: "faq-question-viewall mt-3"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    state: {
      from: filterOption.viewMoreContextValue || ''
    },
    to: "/faqs"
  }, "View More")))));
}
SVBFaqContextualDropdown.propTypes = {
  filterOption: _propTypes.default.object.isRequired,
  faqsItems: _propTypes.default.array.isRequired,
  extraClasses: _propTypes.default.string
};